export const Breakpoints = {
  Mobile: 699,
  TabletPortrait: 799,
  TabletLandscape: 1199,
}
